<template>
    <div class="quickscan-finish">
        <h1>Aanvraag quickscan</h1>
        <h2>Verzenden</h2>

        <quickscan-stepper :current-step="3" :loading="!loaded"></quickscan-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import QuickscanStepper from '../components/QuickscanStepper';

export default {
    name: 'quickscan-finish',
    components: {
        QuickscanStepper,
    },
    data: () => ({
        loaded: false,

        complete: null,
        valid: null,
        submitted: null,
    }),
    computed: {
        ...mapGetters({ vuex: 'finish' }),
    },
    created: function() {
        const that = this;
        this.quickscanFinishLoad().then(function() {
            that.complete = that.vuex.complete;
            that.valid = that.vuex.valid;
            that.submitted = that.vuex.submitted;

            that.loaded = true;

            that.redirect();
        });
    },
    methods: {
        ...mapActions(['quickscanFinishLoad', 'quickscanFinishSubmit']),
        redirect: function() {
            const that = this;

            if (this.complete) {
                if (this.valid) {
                    if (this.submitted) {
                        this.$router.replace({ name: 'quickscan_thanks' });
                    } else {
                        this.loaded = false;

                        this.quickscanFinishSubmit({ submitted: true }).then(function() {
                            that.complete = that.vuex.complete;
                            that.valid = that.vuex.valid;
                            that.submitted = that.vuex.submitted;

                            that.loaded = true;

                            that.redirect();
                        });
                    }
                } else {
                    this.$router.replace({ name: 'quickscan_rejected' });
                }
            } else {
                this.$router.replace({ name: 'quickscan_incomplete' });
            }
        },
    },
};
</script>
